import ApiCaller from './ApiCaller';
import baseAjaxConfig, { headers } from './BaseAjaxConfig';

export const GET_CAMPAIGN_SUMMARY_REQUEST = 'GET_CAMPAIGN_SUMMARY_REQUEST';
export const GET_CAMPAIGN_SUMMARY_SUCCESS = 'GET_CAMPAIGN_SUMMARY_SUCCESS';
export const GET_CAMPAIGN_SUMMARY_ERROR = 'GET_CAMPAIGN_SUMMARY_ERROR';

export const GET_CAMPAIGN_PLAY_REQUEST = 'GET_CAMPAIGN_PLAY_REQUEST';
export const GET_CAMPAIGN_PLAY_SUCCESS = 'GET_CAMPAIGN_PLAY_SUCCESS';
export const GET_CAMPAIGN_PLAY_ERROR = 'GET_CAMPAIGN_PLAY_ERROR';

export const GET_CAMPAIGN_NEXT_REQUEST = 'GET_CAMPAIGN_NEXT_REQUEST';
export const GET_CAMPAIGN_NEXT_SUCCESS = 'GET_CAMPAIGN_NEXT_SUCCESS';
export const GET_CAMPAIGN_NEXT_ERROR = 'GET_CAMPAIGN_NEXT_ERROR';

export const GET_CAMPAIGN_ACTION_REQUEST = 'GET_CAMPAIGN_ACTION_REQUEST';

export function fetchCampaignSummary() {
	return dispatch => {
		dispatch(requestGetCampaignSummary());
		return ApiCaller.get(
			Object.assign({}, baseAjaxConfig, {
				headers,
				pathname: `/api/1/game/campaign/user-campaign-summary`
			})
		).then(
			json => dispatch(receiveGetCampaignSummarySuccess(json['RESPONSE'])),
			err => {
				dispatch(receiveGetCampaignSummaryError(err));
			}
		);
	};
}

const requestGetCampaignSummary = () => {
	return {
		type: GET_CAMPAIGN_SUMMARY_REQUEST
	};
};

const receiveGetCampaignSummarySuccess = response => {
	return {
		type: GET_CAMPAIGN_SUMMARY_SUCCESS,
		data: response
	};
};

const receiveGetCampaignSummaryError = errorParam => {
	return {
		type: GET_CAMPAIGN_SUMMARY_ERROR,
		error: errorParam
	};
};

export function fetchCampaignPlay() {
	return dispatch => {
		dispatch(requestGetCampaignPlay());
		return ApiCaller.post(
			Object.assign({}, baseAjaxConfig, {
				headers,
				pathname: `/api/1/game/campaign/play`
			})
		).then(
			json => dispatch(receiveGetCampaignPlaySuccess(json['RESPONSE'])),
			err => {
				dispatch(receiveGetCampaignPlayError(err));
			}
		);
	};
}

const requestGetCampaignPlay = () => {
	return {
		type: GET_CAMPAIGN_PLAY_REQUEST
	};
};

const receiveGetCampaignPlaySuccess = response => {
	return {
		type: GET_CAMPAIGN_PLAY_SUCCESS,
		data: response
	};
};

const receiveGetCampaignPlayError = errorParam => {
	return {
		type: GET_CAMPAIGN_PLAY_ERROR,
		error: errorParam
	};
};

export function fetchCampaignNext() {
	return dispatch => {
		dispatch(requestGetCampaignNext());
		return ApiCaller.post(
			Object.assign({}, baseAjaxConfig, {
				headers,
				pathname: `/api/1/game/campaign/next`
			})
		).then(
			json => dispatch(receiveGetCampaignNextSuccess(json['RESPONSE'])),
			err => {
				dispatch(receiveGetCampaignNextError(err));
			}
		);
	};
}

const requestGetCampaignNext = () => {
	return {
		type: GET_CAMPAIGN_NEXT_REQUEST
	};
};

const receiveGetCampaignNextSuccess = response => {
	return {
		type: GET_CAMPAIGN_NEXT_SUCCESS,
		data: response
	};
};

const receiveGetCampaignNextError = errorParam => {
	return {
		type: GET_CAMPAIGN_NEXT_ERROR,
		error: errorParam
	};
};

export function sendCampaignAction(actionId) {
	return dispatch => {
		dispatch(requestGetCampaignAction());
		return ApiCaller.post(
			Object.assign({}, baseAjaxConfig, {
				headers,
				pathname: `/api/1/game/campaign/action/${actionId}`
			})
		);
	};
}

const requestGetCampaignAction = () => {
	return {
		type: GET_CAMPAIGN_ACTION_REQUEST
	};
};
